function waitForElement(selector, callback) {
  const observer = new MutationObserver(() => {
    const element = document.querySelector(selector);
    if (element) {
      observer.disconnect();
      callback(element);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener("DOMContentLoaded", function () {
  waitForElement('.vip-tier-table th .current-tier-label', (label) => {
    const th = label.closest('th');
    const index = Array.from(th.parentNode.children).indexOf(th) + 1;
    document.querySelectorAll('.vip-tier-table tr').forEach(row => {
      const cell = row.children[index - 1];
      if (cell) cell.classList.add('highlight');
    });
  });
  waitForElement('.label-row-vip-tier-mobile .current-tier-label', (label) => {
    const th = label.closest('.bon-card-body').classList.add('highlight');;
  });
  // connected
  waitForElement('#bon-onclick-scrollto-earning', (button) => {
      document.querySelector('.bon-body').classList.add('connected');
      document.querySelector('.bon-header-size').innerHTML = 'My Wear Moi<br>Rewards';
  });
  waitForElement('#bon-onclick-joinBon', (button) => {
    document.querySelector('.bon-body').classList.add('not-connected');
    document.querySelector('.bon-header-size').innerHTML = 'Wear Moi<br>Rewards';
    const accountLink = document.querySelector('.header__account-link a');
    const loginUrl = accountLink.getAttribute('href');

    const newLoginLink = document.createElement('a');
    newLoginLink.className = button.className;
    newLoginLink.href = loginUrl;
    newLoginLink.textContent = button.textContent;

    const newAccountLink = document.createElement('a');
    newAccountLink.className = document.querySelector('#bon-onclick-loginBon').className;
    newAccountLink.href = loginUrl;
    newAccountLink.textContent = document.querySelector('#bon-onclick-loginBon').textContent;

    button.replaceWith(newLoginLink);
    document.querySelector('#bon-onclick-loginBon').replaceWith(newAccountLink);
  });
});